var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-layout',{staticClass:"v-input__icon--append"},[_c('v-icon',{staticClass:"primary--text"},[_vm._v("keyboard_arrow_down")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }